module.exports = __webpack_public_path__ + "media/feature-icons/image_capture-65b537e1.svg";